const util = {
	// 获取url参数值
	getParamVal: function(name) {
		let regex = new RegExp(
				'[?&]' + encodeURIComponent(name) + '\\=([^&#]+)'
			),
			value = (location.search.match(regex) || ['', ''])[1];
		return decodeURIComponent(value);
	},
	dataURLtoBlob: function(dataurl, filename) {
		const arr = dataurl.split(',');
		const mime = arr[0].match(/:(.*?);/)[1];
		const bstr = atob(arr[1]);
		let n = bstr.length;
		const u8arr = new Uint8Array(n);
	
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		const theBlob = new Blob([u8arr], { type: mime });
		theBlob.lastModifiedDate = new Date();
		theBlob.name = filename;
		return theBlob;
	}
};

export default util;



// WEBPACK FOOTER //
// ./src/module/basic/util/index.js